import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import BusinessDataForm from './BusinessDataForm'
import OwnerDataForm from './OwnerDataForm'
import PasswordForm from './PasswordForm'
import AddressForm from './AddressForm'
import Confirmation from './Confirmation'
import MainButton from 'components/Buttons/MainButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaCheck, FaChevronLeft, FaWhatsapp } from 'react-icons/fa'

import {
  Container,
  Column,
  StepRow,
  StepContainer,
  StepCircle,
  StepLabel,
  StepLine,
  Circle,
  SmallButton,
  Title,
  InfoText
} from './styles'

export default function SignUp () {
  const location = useLocation ()
  const company_id = location.state?.company_id

  const steps = [
    {number: 0, label: 'Dados do salão'},
    {number: 1, label: 'Responsável'},
    {number: 2, label: 'Segurança'},
    {number: 3, label: 'Endereço'},
    {number: 4, label: 'Confirmar'}
  ]

  const business = AuthService.getUser ()
  const [currentStep, setCurrentStep] = useState (steps[0])
  const [loading, setLoading] = useState (true)
  const [services, setServices] = useState ([])
  const [socialMedias, setSocialMedias] = useState ([])
  
  const [businessData, setBusinessData] = useState ({
    company_id,
    parent_id: business?.id || null,
    logo: null,
    name: '',
    corporate_name: '',
    cnpj: '',
    email: '',
    email_confirmation: '',
    phone: '',
    cellphone: '',
    owner: '',
    owner_email: '',
    owner_phone: '',
    password: '',
    password_confirmation: '',
    social_medias: [],
    address: {
      description: business?.id ? 'Filial' : 'Matriz',
      route: '',
      number: '',
      complement: '',
      is_commercial_building: false,
      district: '',
      city: '',
      state: '',
      postal_code: '',
      latitude: 0,
      longitude: 0
    }
  })

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const { data: socialMedias } = await cutileiApi.get ('/social_medias')
      const { data: cutileiServices } = await cutileiApi.get (
        '/services?status=active&cutilei_services=true'
      )

      setSocialMedias (socialMedias)
      setServices (cutileiServices.map (service => ({
        id: service.id,
        price: service.price,
        comission_percentage: 0.5,
        duration: 0,
        max_delay: service.name.toLowerCase ().includes ('pé e mão') ? 10 : 7
      })))
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const prevStep = () => setCurrentStep (steps[currentStep.number - 1])
  const nextStep = () => setCurrentStep (steps[currentStep.number + 1])

  const handleFormSubmitted = formData => {
    setBusinessData ({ ...businessData, ...formData })
    nextStep ()
  }

  return (
    <Container>
      <Title>Cadastrar salão</Title>
      <StepRow>
        {steps.map ((step, index) => (
          <StepContainer key={index}>
            <StepCircle step={step} currentStep={currentStep}>
              {currentStep.number > step.number ? (
                <FaCheck color='#FFFFFF' size={14}/>
              ) : (
                <InfoText>{step.number + 1}</InfoText>
              )}
            </StepCircle>
            <StepLabel>{step.label}</StepLabel>
          </StepContainer>
        ))}
        <StepLine currentStep={currentStep.number}/>
      </StepRow>
      {currentStep.number > 0 && (
        <SmallButton onClick={prevStep}>
          <Circle>
            <FaChevronLeft color='#FFFFFF' size={14} style={{marginLeft: -2}}/>
          </Circle>
          <InfoText style={{ margin: 0, fontWeight: 500 }}>
            Voltar
          </InfoText>
        </SmallButton>
      )}
      {loading ? <Loading/> : (
        <>
          {currentStep.number === 0 && (
            <BusinessDataForm
              businessData={businessData}
              socialMedias={socialMedias}
              onFormSubmitted={handleFormSubmitted}
            />
          )}
          {currentStep.number === 1 && (
            <OwnerDataForm businessData={businessData} onFormSubmitted={handleFormSubmitted}/>
          )}
          {currentStep.number === 2 && (
            <PasswordForm businessData={businessData} onFormSubmitted={handleFormSubmitted}/>
          )}
          {currentStep.number === 3 && (
            <AddressForm businessData={businessData} onFormSubmitted={handleFormSubmitted}/>
          )}
          {currentStep.number === 4 && (
            <Confirmation businessData={businessData} services={services}/>
          )}
          <Column>
            <InfoText>
              Precisa de ajuda?
            </InfoText>
            <MainButton
              label='Fale conosco'
              leftIcon={<FaWhatsapp size={18} style={{marginBottom: 2}}/>}
              onClick={() => window.open ('https://wa.me/message/SH5AWAQ6UP4IF1', '_blank')}
              width={160}
            />
          </Column>
        </>
      )}
    </Container>
  )
}
